import { render, staticRenderFns } from "./ExhibitorsCarousel.vue?vue&type=template&id=9c4bbcec&"
import script from "./ExhibitorsCarousel.vue?vue&type=script&lang=js&"
export * from "./ExhibitorsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitorsCarousel.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports